export function getCurrencySymbol(currencyCode) {
    const currencySymbols = {
        'USD': '\u0024', // $
        'EUR': '\u20AC', // €
        'RUB': '\u20BD', // ₽
        'JPY': '\u00A5', // ¥
        'GBP': '\u00A3', // £
        'USDC': '$',
        'USDT': '₮',
        'BTC': '₿'
    };

    if (currencyCode) {
        return currencySymbols[currencyCode.toUpperCase()] || '\u00A4';  // or ¤
    } else {
        return '';
    }
}